<firebase-ui></firebase-ui>

<div class="mat-caption" style="text-align: center">
  Indem Sie fortfahren, stimmen Sie unseren<br><a routerLink="/datenschutz">Nutzungsbedingungen und unserer Datenschutzerklärung</a><br>zu.
</div>
